export default "__VITE_ASSET__CdGH7M2P__"